import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";

export default function PrivateRouter() {
    const isAuthenticated = Cookies.get('token');
    const hasSessionId = sessionStorage.getItem('mid');

    if (isAuthenticated && hasSessionId) {
        return <Outlet />;
    } else {
        return <Navigate to={"/"} replace />;
    }
}

// export default function PrivateRouter() {
//     if (Cookies.get('token')) {
//         return <Outlet />
//     } else {
//         return <Navigate to={"/"} replace />
//     }
// }

// const ProtectedRoute = () => {
//     const { user, loading } = useAuth();

//     if (loading) return null

//     if (!user?.token) return <Navigate to="/" replace />;

//     return <Outlet />;
// };

// export default ProtectedRoute;
